import React from 'react';
import { Typography } from '@waglabs/typography';
export const HelperText = ({ text, error, ...rest }) => (React.createElement(React.Fragment, null, text && (React.createElement(Typography, Object.assign({ variant: "legal", color: error ? 'red' : 'initial' }, rest), text))));
